import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Checkbox, Grid, FormControlLabel } from '@mui/material';
import { TextField, IconButton, LinearProgress } from '@totalsoft/rocket-ui';
import CloudUpload from '@mui/icons-material/CloudUpload';
import CloudDownload from '@mui/icons-material/CloudDownload';
import { withRights } from 'providers/RightsConsumer';
import { BoxActionsWrapper } from 'components/common/CommonStyles';

class OfferPartnerConsentItem extends React.PureComponent {
  state = {
    fileUploadProgress: 0,
    fileUploadInProgress: false
  };

  fileInputRef = React.createRef();

  handleCommentChange = value => {
    this.props.handleChange('comments', value);
  };

  handleSelectChange = e => {
    this.props.handleChange('selected', e.target.checked);
  };

  uploadClick = () => {
    this.fileInputRef.current.value = '';
    this.fileInputRef.current.click();
  };

  handleFileChange = event => {
    if (event.target.files.length > 0) {
      let file = event.target.files[0];
      this.props.handleUpload(file, this.antiPatternCommunicationBetweenParentAndChildComponentYouShouldUseOnlyProps);
    }
  };

  //Parent components pass data down to nested Child components with props
  antiPatternCommunicationBetweenParentAndChildComponentYouShouldUseOnlyProps = progress => {
    this.setState({ fileUploadProgress: progress, fileUploadInProgress: progress === 100 ? false : true });
  };

  render() {
    const { t, item, rights, handleDownload, idx } = this.props;
    const { fileUploadInProgress, fileUploadProgress } = this.state;

    return (
      <Grid container spacing={1} alignItems='center'>
        <input
          type='file'
          style={{ display: 'none' }}
          ref={this.fileInputRef}
          onChange={this.handleFileChange}
          disabled={rights.readOnlyFull || !rights.clientConsentsWrite}
        />
        <Grid item xs={12} sm={6} md={3}>
          <FormControlLabel
            control={
              <Checkbox
                id={'offerPartnerConsentCard_' + idx + '_isSelected'}
                checked={item.selected || false}
                onChange={this.handleSelectChange}
                disabled={rights.readOnlyFull || !rights.clientConsentsWrite || item.isSystem}
              />
            }
            label={item.name}
          />
        </Grid>
        {!rights.clientConsentsWrite ? (
          <Grid item xs={12} sm={6} md={3}>
            <strong>{t('OfferEdit.Client.Consent.AssignedBy')}:</strong>{' '}
            <span id={'offerPartnerConsentCard_' + idx + '_assignedDate'}>
              {item.assignedBy}/{this.props.t('DATE', { date: item.assignedDate })}
            </span>
          </Grid>
        ) : (
          <Grid item xs={12} sm={6} md={3}>
            <strong>{t('OfferEdit.Client.Consent.AssignedBy')}:</strong>{' '}
            <span id={'offerPartnerConsentCard_' + idx + '_assignedDate'}>
              {item.assignedBy}/{this.props.t('DATE', { date: item.assignedDate })}
            </span>
          </Grid>
        )}
        {!rights.clientConsentsWrite ? (
          <Grid item xs={12} sm={6} md={3}>
            <strong>{t('OfferEdit.Client.Consent.ValidUntil')}:</strong>{' '}
            <span id={'offerPartnerConsentCard_' + idx + '_validUntil'}>{this.props.t('DATE', { date: item.validUntil })}</span>
          </Grid>
        ) : (
          <Grid item xs={12} sm={6} md={3}>
            <strong>{t('OfferEdit.Client.Consent.ValidUntil')}:</strong>{' '}
            <span id={'offerPartnerConsentCard_' + idx + '_validUntil'}>{this.props.t('DATE', { date: item.validUntil })}</span>
          </Grid>
        )}
        {!rights.clientConsentsWrite ? (
          <Grid item xs={12} sm={6} md={3}>
            <strong>{t('OfferEdit.Client.Consent.UnassignedBy')}:</strong>{' '}
            <span id={'offerPartnerConsentCard_' + idx + '_unassignedDate'}>
              {item.unassignedBy}/{this.props.t('DATE', { date: item.unassignedDate })}
            </span>
          </Grid>
        ) : (
          <Grid item xs={12} sm={6} md={3}>
            <strong>{t('OfferEdit.Client.Consent.UnassignedBy')}:</strong>{' '}
            <span id={'offerPartnerConsentCard_' + idx + '_unassignedDate'}>
              {item.unassignedBy}/{this.props.t('DATE', { date: item.unassignedDate })}
            </span>
          </Grid>
        )}
        <Grid item xs={12} sm={10}>
          <TextField
            id={'offerPartnerConsentCard_' + idx + '_comments'}
            label={t('OfferEdit.Client.Consent.Comments')}
            multiline
            fullWidth
            rows='2'
            value={item.comments || ''}
            onChange={this.handleCommentChange}
            disabled={rights.readOnlyFull || !rights.clientConsentsWrite}
            inputProps={{
              maxLength: 4000
            }}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          {fileUploadInProgress ? (
            <LinearProgress variant='determinate' value={fileUploadProgress} />
          ) : (
            <BoxActionsWrapper sx={{ justifyContent: 'end' }}>
              <IconButton
                id={'offerPartnerConsentCard_' + idx + '_uploadBtn'}
                color='primary'
                variant='text'
                size='small'
                onClick={this.uploadClick}
                disabled={rights.readOnlyFull || !rights.clientConsentsWrite}
              >
                <CloudUpload />
              </IconButton>
              <IconButton
                id={'offerPartnerConsentCard_' + idx + '_downloadBtn'}
                color='primary'
                variant='text'
                size='small'
                disabled={rights.readOnlyFull || !item.consentFileId || !rights.clientConsentsWrite}
                onClick={() => handleDownload(item.consentFileId)}
              >
                <CloudDownload />
              </IconButton>
            </BoxActionsWrapper>
          )}
        </Grid>
      </Grid>
    );
  }
}

OfferPartnerConsentItem.propTypes = {
  t: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
  rights: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleUpload: PropTypes.func.isRequired,
  handleDownload: PropTypes.func.isRequired,
  idx: PropTypes.number.isRequired
};

export default withTranslation()(withRights(OfferPartnerConsentItem));
